import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import SidebarItem from '@shared/SidebarItem/SidebarItem';
import { List } from '@mui/material';
import { CdnIcon } from '@shared/ui';
import { ModalX, Header, IconButton, BackwardButton } from '../BaseComponents';
import { isRouteSelected } from '../Account/utils';
import { useTheme } from '../theme';
const MobileSidebar = ({ className, title: titleProp, routes, selectedRoute, onBack }) => {
    const [isOpenedMenu, setOpenedMenu] = useState(false);
    const { MobileSidebar: css } = useTheme('MobileSidebar');
    const { t } = useTranslation('Account');
    const title = useMemo(() => {
        var _a;
        if (titleProp) {
            return titleProp;
        }
        return (_a = routes.find(item => (item === null || item === void 0 ? void 0 : item.pathname) === selectedRoute)) === null || _a === void 0 ? void 0 : _a.title;
    }, [routes, selectedRoute, titleProp]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { className: cn(css.mobileSidebar__header, className), left: React.createElement("div", { className: css.mobileSidebar__header_title },
                onBack && (React.createElement(BackwardButton, { className: css.mobileSidebar__header_backwardButton, onClick: onBack })),
                t(title)), right: React.createElement(IconButton, { className: css.mobileSidebar__header_moreButton, onClick: () => setOpenedMenu(!isOpenedMenu) },
                React.createElement(CdnIcon, { icon: "Action/More" })), equalSlotsBasis: false, showEmptySlots: false }),
        React.createElement(ModalX, { classes: {
                top_wrapper: css.mobileSidebar,
                closeButton: css.mobileSidebar__closeButton
            }, isOpen: isOpenedMenu, onClose: () => setOpenedMenu(false), noPadding: true },
            React.createElement("div", { className: css.mobileSidebar__modalTitle }, t('Cabinet menu')),
            React.createElement(List, { className: css.mobileSidebar__items }, routes.map(route => (React.createElement(SidebarItem, { key: route.title, route: route, isSelected: isRouteSelected(route, selectedRoute), onClickCallback: () => setOpenedMenu(false) })))))));
};
export default MobileSidebar;
